export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DOCUMENT = 'document',
}

export interface MediaAsset {
  id: string;
  originalName: string;
  fileName: string;
  filePath: string;
  fileSize: number;
  mimeType: string;
  type: MediaType;
  stakeholderId?: string;
  organizationId?: string;
  uploadedBy: string;
  uploader?: {
    id: string;
    email: string;
  };
  stakeholder?: {
    id: string;
    firstName: string;
    lastName: string;
  };
  organization?: {
    id: string;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface UploadProgress {
  loaded: number;
  total: number;
  percentage: number;
}

export interface MediaUploadOptions {
  stakeholderId?: string;
  organizationId?: string;
  onProgress?: (progress: UploadProgress) => void;
}

export interface MediaGalleryFilter {
  type?: MediaType;
  stakeholderId?: string;
  organizationId?: string;
  search?: string;
}
export type StorageType = 'local' | 's3';

export interface StorageStatus {
  type: StorageType;
  /** Absolute directory for local disk, `endpoint/bucket` for S3 */
  location: string;
  reachable: boolean;
  writable?: boolean;
  error?: string;
}

export interface MissingMediaSample {
  id: string;
  originalName: string;
  createdAt: string;
  stakeholderId: string | null;
  organizationId: string | null;
}

export interface StorageHealthReport {
  primary: StorageStatus;
  fallback: StorageStatus | null;
  total: number;
  checked: number;
  inPrimary: number;
  inFallbackOnly: number;
  missing: number;
  unverified: number;
  missingByMonth: { month: string; count: number }[];
  missingSample: MissingMediaSample[];
  checkedAt: string;
  durationMs: number;
}

export interface StorageRepairResult {
  copied: number;
  failed: number;
}
